import { Grid, Input, InputMask, SelectForm } from 'components'
import { SPACING } from 'utils'

interface IFilterRollDocuments {
  rolDocs?: any[]
  pendencias?: any[]
  tipos?: any[]
  tipoEfetivo?: any[]
  status?: any[]
  control: any
}
export const FilterRollDocuments = ({
  control,
  rolDocs = [],
  pendencias = [],
  tipos = [],
  tipoEfetivo = [],
  status = []
}: IFilterRollDocuments) => {
  return (
    <Grid
      gridCols="1fr 1fr 2.5fr 1fr 1fr 1fr 0.5fr"
      gridGap={`0 ${SPACING.spacing20}`}
      margin={`${SPACING.spacing10} 0 ${SPACING.spacing10} 0`}
    >
      <InputMask
        label="Item"
        placeholder="Nº"
        control={control}
        formValue="nuItem"
        type="number"
        mask="99"
        required
      />
      <SelectForm
        defaultValue={null}
        control={control}
        listOptions={rolDocs}
        label="Rol de Documentos"
        formValue="txtTipoDocumento"
        placeholder="Selecione"
      />
      <SelectForm
        defaultValue={null}
        control={control}
        listOptions={pendencias}
        label="Pendência"
        placeholder="Selecione"
        formValue="descPendencia"
      />
      <SelectForm
        defaultValue={null}
        control={control}
        listOptions={tipos}
        label="Tipo"
        formValue="tipoPendencia"
        placeholder="Selecione"
      />
      <SelectForm
        defaultValue={null}
        control={control}
        listOptions={tipoEfetivo}
        formValue="cdTipoEfetivo"
        label="Tipo Efetivo"
        placeholder="Selecione"
      />
      <SelectForm
        defaultValue={null}
        control={control}
        formValue="cdStatusEfetivo"
        listOptions={status}
        label="Status do Efetivo"
        placeholder="Selecione"
      />
    </Grid>
  )
}
